export default __webpack_public_path__ + "static/media/default-ship.f1962a26.jpg";